import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/clientErrorLog',
  title: window.language['menu.log.clientErrorLog'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('../Org/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/ClientErrorLog/index.js